import WebFwf from './webFwf';

export default (config, context) => {
  return new WebFwf(config, context);
};
